<template lang="pug">
.new-order
  HScroll(:currentStep='currentStep')
    transition(name='simple-fade' mode='out-in')
      //- STEP 1 (always visible)
      CustomerChooser(v-model='customer' @input='setCurrentStep(STEP_SELECT_CUSTOMER)')

    transition(name='simple-fade' mode='out-in')
      //- STEP 2 (visible if customer is selected)
      .d-flex.p-0(v-if='customer')
        CustomerInsight(
          :data='customer'
        )
          //- :customerId='customer.id'
        //- GenericCard.actionType(size='25')
        //-   MenuItem(
        //-     :class="{'upa-is-active': actionType === 'order'}"
        //-     title='ทำรายการขาย'
        //-     @click="setActionType('order')")
        //-   MenuItem(
        //-     :class="{'upa-is-active': actionType === 'quotation'}"
        //-     title='ทำใบเสนอราคา'
        //-     @click="setActionType('quotation')")
        ActionSelectorMenu(:items='actionItems' v-model='actionType')

    transition(name='simple-fade' mode='out-in')
      //- STEP 3 (visible if actionType is selected)
      GenericCard.actionDetail(size='33' v-if='actionType')
        .d-flex.flex-column
          SelectionGroup(
            title="เลือกประเภทบิล"
            :choices=`[
              { value: 0, text: 'บิลมี VAT' },
              { value: 1, text: 'บิลไม่มี VAT' },
            ]`
            v-model="receiptType"
          )
          SelectionGroup(
            title="เลือกชื่อลูกค้า"
            :choices=`[
              { value: 1, text: 'ชื่อที่ 1' },
              { value: 2, text: 'ชื่อที่ 2' },
              { value: 3, text: 'ชื่อที่ 3' },
            ]`
            v-model="customerNameIndex"
          )
          SelectionGroup(
            title="ชื่อพิเศษ"
            :choices=`[
              { value: 1, text: 'ใช้ชื่อพิเศษ' },
              { value: 0, text: 'ไม่ใช้' },
            ]`
            v-model="useSpecialName"
          )
          SelectionGroup(
            title="ประเภทการส่ง"
            :choices=`[
              { value: 'store', text: $dictionary.deliveryType.store },
              {
                value: 'branch_and_site',
                text: $dictionary.deliveryType.branch_and_site,
                hasExtraField: true,
              },
              { value: 'pickup', text: $dictionary.deliveryType.pickup },
              { value: 'forward', text: $dictionary.deliveryType.forward, hasExtraField: true },
            ]`
            v-model="deliveryType"
            :extraField="deliveryTypeExtra"
            @extraInput="deliveryTypeExtra = $event"
          )
          SelectionGroup(
            title="เลือกวิธีขนส่ง"
            :choices='availableCarriers'
            v-model="deliveryCarrier"
          )
          SelectionGroup(
            v-if="root"
            title="เลือกคลัง"
            :choices='availableWarehouse'
            v-model="warehouse"
          )

    //- STEP 4 (visible if actionDetail is provided)
    transition(name='simple-fade' mode='out-in' @enter='setCurrentStep(STEP_ORDER_DETAIL)')
      //- receiptType = helps with tax/no tax, deliveryType = helps showing
      OrderDetail(
        :customer="customer"
        :preSelectedProducts='preSelectedProducts'
        :extraRemarks='extraRemarks'
        :isQuotation='isQuotation'
        :isVat="(receiptType === 0)? true: false"
        :deliveryType="deliveryType"
        :deliveryTypeExtra="deliveryTypeExtra"
        :deliveryCarrier="deliveryCarrier"
        :warehouse="warehouse"

        :customerNameIndex='customerNameIndex',
        :useSpecialName='(useSpecialName === 1) ? true:false'

        v-if="isActionDetailsValid"
        @done="onOrderSubmitted($event)"

        :editingOrderId='editingOrderId'
      )

  template(v-if='editingOrderId')
    modal(
      name='success-modal'
      width='320px' height='320px'
      transition='modal-transition'
      :clickToClose='false'
    )
      EditOrderDonePopup
  template(v-else)
    modal(
      name='success-modal'
      width='640px' height='540px'
      transition='modal-transition'
      :clickToClose='false'
    )
      .h-100.d-flex.flex-column.justify-content-center.align-items-center
        NewOrderDonePopup(
          :orderId='dialogOrderId'
          :isQuotation='isQuotation'
        )

</template>

<script>
import EditOrderDonePopup from '@/components/new-order/EditOrderDonePopup.vue';
import NewOrderDonePopup from '@/components/new-order/NewOrderDonePopup.vue';
import SelectionGroup from '@/components/SelectionGroup.vue';
import CustomerChooser from '@/components/customers/CustomerChooser.vue';
import CustomerInsight from '@/components/customers/CustomerInsight.vue';
import OrderDetail from '@/components/new-order/panels/OrderDetail.vue';

// TODO: accquire data from OrderDetail and implement API final

export default {
  data: () => ({
    actionItems: {
      order: 'ทำรายการขาย',
      quotation: 'ทำใบเสนอราคา',
    },

    availableCarriers: [],
    availableWarehouse: [],

    isDone: false,
    customer: null,
    actionType: null,
    // actionDetail: null,
    receiptType: null,
    deliveryType: null,
    deliveryCarrier: null,
    deliveryTypeExtra: '',
    preSelectedProducts: [],
    extraRemarks: '',

    customerNameIndex: null,
    useSpecialName: null,

    warehouse: null,

    currentStep: 0,
    STEP_SELECT_CUSTOMER: 1,
    STEP_SELECT_ACTION: 2,
    STEP_ACTION_DETAIL: 3,
    STEP_ORDER_DETAIL: 4,

    backOrdersToRemove: [],
    quotationIdToRemove: null,
    editingOrderId: null,

    dialogOrderId: null,
  }),
  computed: {
    isActionDetailsValid() {
      return this.receiptType !== null
          && this.deliveryType !== null
          && this.customerNameIndex !== null
          && this.useSpecialName !== null;
    },
    isQuotation() {
      return this.actionType === 'quotation';
    },
  },
  watch: {
    customer() {
      this.loadAvailableCarriers();
      this.loadAvailableWarehouses();
    },
    actionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ACTION);
      }
    },
  },
  async mounted() {
    // const { customerId } = this.$route.params;
    const {
      customer,
      products,
      warehouse,
      ship_type: shipType,
      ship_to: shipTo,
      remarks,

      has_vat: hasVat,
      package_carrier_id: packageCarrierId,

      backOrdersToRemove,
      quotationIdToRemove,
      // isEditingOrder,
      editingOrderId,
    } = this.$route.params;

    if (warehouse) this.warehouse = warehouse;
    if (this.warehouse === 'null') this.warehouse = null;

    // if redirected from BackOrderList / QuotationList
    if (customer) {
      this.customer = customer;
      this.actionType = 'order';
      // alert(JSON.stringify(Object.keys(this.$route.params)));
      // console.log(this.$route.params);
    }

    if (hasVat || shipType || shipTo || packageCarrierId) {
      // ACTION_TYPE
      this.receiptType = hasVat;
      this.deliveryType = shipType;
      this.deliveryTypeExtra = shipTo;
      this.deliveryCarrier = packageCarrierId;
    }

    this.extraRemarks = remarks;

    if (products) {
      //  populate the products list
      const preSelectedProducts = products.map((prod) => {
        const res = {
          ...prod,

          sellPrice: `${Number(prod.price) / Number(prod.amount)}`,
          // has to be string, for some reason.
          // otherwise, won't be able to submit

          // productCode: prod.product.id,
          // productName: prod.product.name,
        };

        res.product = {
          ...prod,
          productCode: prod.product.id,
          productName: prod.product.name,
        };
        return res;
      });

      // fetch the price levels of each products
      for (let i = 0; i < preSelectedProducts.length; i += 1) {
        const PROD = preSelectedProducts[i];
        // eslint-disable-next-line
        const res = await this.$api.product.getLevel(PROD.product.productCode, customer.grade);
        PROD.product.levels = res.data;
        // PROD.levels = res.data;
      }

      this.preSelectedProducts = preSelectedProducts;
    }

    //
    // Stuffs to delete after submitting the order.
    //
    if (backOrdersToRemove) {
      this.backOrdersToRemove = backOrdersToRemove;
    }
    if (quotationIdToRemove) {
      this.quotationIdToRemove = quotationIdToRemove;
    }
    if (editingOrderId) {
      this.editingOrderId = editingOrderId;
    }
  },
  methods: {
    async loadAvailableCarriers() {
      const res = await this.$api.order.availableCarrierForCustomer(this.customer.id);
      if (res.status === 200) {
        // console.log(res);
        this.availableCarriers = res.data;
      }
    },

    async loadAvailableWarehouses() {
      const res = await this.$api.order.availableWarehouse();
      if (res.status === 200) {
        this.availableWarehouse = res.data;
      }
    },

    setCurrentStep(step) {
      // change step to step - 1 => wait 50ms => change step to the actual value
      // so the change is always noticed by the HSrcoll component
      // HSroll will then scoll to the right, so the new view is visible to the user
      this.currentStep = step - 1;
      setTimeout(() => {
        this.currentStep = step;

        //
        // 1. PREPARE the data for each STEP
        // 2. RESET the data gathered from further steps
        //    so the data won't be mixed up
        //

        // STEP 1
        if (step < this.STEP_SELECT_CUSTOMER) {
          // ..
          this.customer = null;
        }

        // STEP 2
        if (step < this.STEP_SELECT_ACTION) {
          // this.actionType = null;
        }

        // STEP 3
        if (step < this.STEP_ACTION_DETAIL) {
          // this.receiptType = null;
          // this.deliveryType = null;
          // this.deliveryCarrier = null;

          // fuck it, i'm disabling these for now
          // since it prevent setting these PARAMS
          // when creating new order from a quotation

          // TODO: bring it back later
        }
      }, 50);
    },
    // setActionType(actionType) {
    //   this.actionType = actionType;
    //   this.setCurrentStep(this.STEP_SELECT_ACTION);
    // },

    async onOrderSubmitted(eventOrderId) {
      this.dialogOrderId = eventOrderId;

      if (this.backOrdersToRemove) {
        for (let i = 0; i < this.backOrdersToRemove.length; i += 1) {
          const { orderId, productIds } = this.backOrdersToRemove[i];

          // eslint-disable-next-line
          const res = await this.$api.order.removeBackOrderItems(orderId, productIds);
          console.log(res);
        }
      }

      const { quotationIdToRemove } = this;
      if (quotationIdToRemove) {
        const res = await this.$api.order.deleteQuotation(quotationIdToRemove);
        console.log(res);
      }

      this.$modal.show('success-modal');
    },
  },
  props: {
    root: {
      default: false,
    },
  },
  components: {
    CustomerChooser,
    CustomerInsight,
    OrderDetail,
    SelectionGroup,
    NewOrderDonePopup,
    EditOrderDonePopup,
  },
};
</script>

<style lang="scss">
.new-order {
  > .h-scroll {
    height: 100%;
  }
}
</style>
